import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { selectUserToken } from "../../../../../features/userSlice";
import { useEffect, useMemo } from "react";
import { ReceiptsEndPointLogic } from "../../../../../logic/Finance/ProviderExpense/ReceiptsEndpointLogic";
import {
  formatDateToDDMMYYYY,
  formatNumber,
} from "../../../../../utils/helpers";

export default function FailedReceipts({ failedReceiptsWithDetails }: any) {
  const oauthTokenHeader = useSelector(selectUserToken) as any;

  useEffect(() => {
    const getCompanyAndCurrencyList = async () => {
      try {
        await ReceiptsEndPointLogic.getAllCompanies(oauthTokenHeader);
        await ReceiptsEndPointLogic.getAllCurrencies(oauthTokenHeader);
      } catch (error) {
        console.error("Error fetching company and currency list:", error);
      }
    };
    getCompanyAndCurrencyList();
    // eslint-disable-next-line
  }, []);

  const { allCurrencies, allCompanies } = useSelector(
    (state: any) => state.receipts,
  );

  const groupedReceipts = useMemo(() => {
    const grouped: { [key: string]: any[] } = {};
    failedReceiptsWithDetails?.forEach((receipt: any) => {
      const reason = receipt?.reason || "Unknown reason";
      if (!grouped[reason]) {
        grouped[reason] = [];
      }
      grouped[reason].push(receipt);
    });
    return grouped;
  }, [failedReceiptsWithDetails]);

  return (
    <>
      {Object.entries(groupedReceipts).map(([reason, receipts]) => (
        <Box key={reason} sx={{ mb: 4 }}>
          <Box sx={{ mb: 1 }}>
            <Typography fontWeight="medium">{reason}</Typography>
          </Box>
          <TableContainer className="receiptsTable" sx={{ my: 3 }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Company</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Receipt Number</TableCell>
                  <TableCell>Receipt Amount</TableCell>
                  <TableCell>FME Record ID</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {receipts.map((receipt: any) => (
                  <TableRow key={receipt?.receipt_id}>
                    <TableCell>
                      {
                        allCompanies?.find(
                          (company: any) =>
                            company?.shared_uid === receipt?.company_shared_uid,
                        )?.finance_company_name
                      }
                    </TableCell>
                    <TableCell>
                      {formatDateToDDMMYYYY(receipt?.receipt_date) || ""}
                    </TableCell>
                    <TableCell>{receipt?.receipt_id}</TableCell>
                    <TableCell>
                      <Box display={"flex"} alignItems={"center"}>
                        {formatNumber(receipt?.receipt_amount)}
                        <Stack
                          sx={{
                            color: "rgba(0, 0, 0, 0.56)",
                            fontSize: "18px !important",
                            fontWeight: "400",
                            ml: 0.5,
                          }}
                        >
                          {
                            allCurrencies?.find(
                              (currency: any) =>
                                currency?.shared_uid ===
                                receipt?.receipt_currency_shared_uid,
                            )?.currency_symbol
                          }
                        </Stack>
                      </Box>
                    </TableCell>
                    <TableCell>
                      {Array.isArray(receipt?.fme_records) &&
                      receipt.fme_records.filter(
                        (v: any) => v !== null && v !== "",
                      ).length > 0
                        ? receipt.fme_records
                            .filter((v: any) => v !== null && v !== "")
                            .join(", ")
                        : "-"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ))}
    </>
  );
}
